import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { documentFootnotes, SanityDocumentFootnotes } from './footnotes';
import { richText } from './richText';

export const SanityGlossaryTerm = z.object({
  _id: z.string(),
  title: z.string(),
  href: z.string(),
  description: z.string().nullable(),
  definition: SanityBasicText,
  backLinkLabel: z.string(),
  sidebar: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      href: z.string(),
    }),
  ),
  footnotes: SanityDocumentFootnotes.optional().nullable(),
});
export type SanityGlossaryTerm = z.infer<typeof SanityGlossaryTerm>;

export const glossaryTerm = groq`*[_type == 'glossaryTerm' && slug.current == $slug][0] {
  _id,
  title,
  'href': '/glossary/' + slug.current,
  "description": coalesce(pt::text(lede), pt::text(definition)),
  definition[] ${richText},
  'backLinkLabel': *[_type == 'glossary'][0].glossaryTermDetailBackLinkLabel,
  'sidebar': *[_type == 'glossaryTerm'] | order(title asc) {
    '_key': _id,
    title,
    'href': '/glossary/' + slug.current,
  },
  footnotes ${documentFootnotes},
}`;
